module.exports = __webpack_public_path__ + "img/0.ec8828c6.svg";